// the v1 API categories for "Billing" notification preferences
export const billingCategories = [
  'bill_generated',
  'bill_due',
  'bill_past_due',
  'payment_failure',
  'payment_success'
];

// the v1 API categories for "Outage" notification preferences
export const outageCategories = [
  'outages',
  'pre_cutoff',
  'post_cutoff'
];
